import { useEffect, useState } from "react";
import { fixchargeOrder } from "../../services/orderService";

export const useGetAllExchargeOrderData = (orderId) => {
    const [data, setData] = useState();
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const getAllData = async () => {
        setIsLoading(true);
        try {
            const response = await fixchargeOrder(orderId);
            if(response){
                setData(response);
                setIsLoading(false);
            }
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllData();
    },[])

    const refresh = () => {
        getAllData();
    }

    return {data, error, isLoading, refresh}
}